import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "monitorKpiModal",
   components: { customModal },
  props: {
    kpiwithscores: {
      type: Object,
      default: () => ({}),
    }
  },
  methods: {
    closeModal() {
      console.log("Closing Modal from child");
      this.$emit("closeModal");
    },
  },
};